import { Stack, mergeStyleSets, Text } from "@fluentui/react";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import VideoPlayer from "../VideoPlayer/VideoPlayer";

const Featured: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const images = (require as any).context("../../assets", true);
    const linkimg = images("./LinkedIn.png");
    const isRTL = document.body.classList.contains('langdirection-rtl');
    const styles = mergeStyleSets({
        featuredContainer: {
            background: "linear-gradient(92.59deg, #231D39 2.31%, #2E3C6F 99.29%)",
            padding: "20px 20px",
        },
        contentWrapper: {
            display: "flex",
            flexDirection: "row",
            gap: "20px",
            alignItems: "center",
            justifyContent: "center",
            margin: "45px auto",
            "@media (max-width: 1024px)": {
                flexDirection: "column",
                textAlign: "center",
            },
            "@media (max-width: 550px)": {
                margin: "0px"
            },
        },
        videoContainer: {
            flex: 1,
            maxWidth: "40%",
            "@media (max-width: 1024px)": {
                maxWidth: "100%",
            },
            "@media (min-width: 1440px)": {
                maxWidth: "30%",
            },

        },
        textContainer: {
            flex: 1,
            maxWidth: "60%",
            color: "#fff",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            paddingTop: "1rem",
            "@media (max-width: 1024px)": {
                maxWidth: "100%",
                textAlign: "center",
                alignItems: "center",
                paddingTop: "0px",
            },
        },
        textContainerRtl: {
            direction: "rtl",
            textAlign: "right",
            flex: 1,
            maxWidth: "50%",
            color: "#fff",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            paddingTop: "1rem",
            "@media (max-width: 1024px)": {
                maxWidth: "100%",
                direction: "rtl",
                textAlign: "right",
                paddingTop: "0px",
            },
        },
        textContainersubheading: {
            flex: 1,
            maxWidth: "60%",
            color: "#fff",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            paddingTop: "1rem",
            "@media (max-width: 1024px)": {
                maxWidth: "100%",
                textAlign: "center",
                alignItems: "center",
                paddingTop: "0px",
            },
        },
        textContainersubheadingRtl: {
            direction: "rtl",
            textAlign: "right",
            flex: 1,
            maxWidth: "50%",
            color: "#fff",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            paddingTop: "2.5rem",
            "@media (max-width: 1024px)": {
                maxWidth: "100%",
                direction: "rtl",
                textAlign: "right",
                paddingTop: "0px",
            },
        },
        Featured: {
            fontWeight: "600",
            fontSize: "24px",
            lineHeight: "32.4px",
            letterSpacing: "-2%",
            color: " #FAFAFA",
            paddingBottom: "16px",
        },
        heading: {
            fontSize: "32px",
            lineHeight: "1.2",
            fontWeight: 600,
            paddingBottom: "20px",
            color: "#fff",
            "@media (max-width: 1024px)": {
                fontSize: "24px",
            },
        },
        subheading: {
            fontSize: "16px",
            fontWeight: 400,
            color: "#B8B8B8",
            paddingBottom: "20px",
            "@media (max-width: 1024px)": {
                fontSize: "16px",
            },
        },
        description: {
            fontSize: "16px",
            lineHeight: "1.5",
            color: "#fff",
            marginBottom: "20px",
            "@media (max-width: 1024px)": {
                fontSize: "14px",
            },
        },
        linkedInLogo: {
            marginTop: "20px",
            width: "20px",
            height: "20px",
        },
        courseLink: {
            display: "flex",
            alignItems: "center",
            gap: "8px",
            "@media (max-width: 1024px)": {
                justifyContent: "center", // Centers it on mobile
                marginTop: "0px",
            },
        },
        linkedinLogo: {
            width: "24px",
            height: "24px",
        },
        courseText: {
            fontSize: "14px",
            color: "#ffff",
            fontWeight: 400,
            textDecoration: "none",
            "&:hover": {
                textDecoration: "underline"
            }
        }
    });

    const heading = t("Featured.heading", "null")?.trim();
    const subheading = t("Featured.subheading", "null")?.trim();
    const description = t("Featured.Description", "null")?.trim();
    const imageUrl = t("Featured.imageUrl", "null")?.trim();
    const videoURL = t("Featured.videoURL", "null")?.trim();
    const Course = t("Featured.Course", "null")?.trim();
    const CourseUrl = t("Featured.CourseUrl", "null")?.trim();
    const Featured = t("Featured.Featured", "null")?.trim();
    const logoUrl = t("Featured.CourseLogo", "null")?.trim();

    if (!Featured || Featured === "null" || !heading || heading === "null" || !imageUrl || imageUrl === "null" || !videoURL || videoURL === "null" || !description || description === "null") {
        return null;
    }

    return (
        <Stack className={styles.featuredContainer}>
            <Stack className={styles.contentWrapper}>
                {/* Video Player */}
                <Stack className={styles.videoContainer}>
                    <VideoPlayer videoUrl={videoURL} thumbnail={imageUrl} section="featured" />
                </Stack>

                {/* Text Content */}
                <Stack className={isRTL ? (!subheading && subheading === "null" ? styles.textContainerRtl : styles.textContainersubheadingRtl)
                    : (!subheading && subheading === "null" ? styles.textContainer : styles.textContainersubheading)}>

                    <Text className={styles.heading}>{heading}</Text>
                    {subheading && subheading !== "null" && (
                        <Text className={styles.subheading}>{subheading}</Text>
                    )}
                    <Text className={styles.description}>{description}</Text>
                    {/* LinkedIn Logo */}
                    {Course && Course !== "null" && Course.trim() !== "" &&
                        CourseUrl && CourseUrl !== "null" && CourseUrl.trim() !== "" && (
                            <Stack horizontal verticalAlign="center" className={styles.courseLink}>
                                <a href={CourseUrl} target="_blank" rel="noopener noreferrer" className={styles.courseText}>
                                    <Stack horizontal tokens={{ childrenGap: 8 }} verticalAlign="center">
                                        {logoUrl && logoUrl !== "null" && logoUrl.trim() !== "" ? (
                                            <img src={logoUrl} alt="Course Logo" className={styles.linkedinLogo} />
                                        ) : CourseUrl.toLowerCase().includes("linkedin.com") ? (
                                            <img src={linkimg} alt="LinkedIn Logo" className={styles.linkedinLogo} />
                                        ) : null}
                                        <span>{Course}</span>
                                    </Stack>
                                </a>
                            </Stack>
                        )}


                </Stack>
            </Stack>
        </Stack>
    );
};

export default Featured;
